import { useState } from "react";

import { useNavigate } from "react-router-dom";

type useCategoryInputProps = {
    defaultCategory: string;
};

type useCategoryProps = {
    category: string;
    changeCategory: (category: string) => void;
};

const useCategories = ({ defaultCategory }: useCategoryInputProps): useCategoryProps => {
    const [category, setCategory] = useState(defaultCategory);
    const navigate = useNavigate();

    const changeCategory = (newCategory: string) => {
        setCategory(newCategory);
        navigate(".", { replace: true, state: { filterId: newCategory } });
    };

    return {
        category,
        changeCategory,
    };
};

export default useCategories;
